import React, { useEffect, useRef, useState } from "react";
import "../HomeWork/HomeWork.css";
// this component css comes from hwMangement/HomeWorkMain.css this css also use in homeMain compennt
import "../PreRead/PreRead.css";
import "../Activity/Activity.css";
import SubjBoxProps from "../Activity/Subj_Box/SubjBoxProps";
import { Popup } from "semantic-ui-react";
import FilterBox from "../PreRead/Filter_Box/FilterBox";
import ActivityPendingSubjDetail from "./Pending/ActivityPendingSubjDetail";
import ActivityOnReviewSubDetail from "./OnReview/ActivityOnReviewSubDetail";
import ActivityCompletedSubDetail from "./Completed/ActivityCompletedSubDetail";
import { useSelector } from "react-redux";
import moment from "moment";
import axios from "../../axios";
import SortedBy from "../PreRead/Filter_Box/SortedBy";
import FilterNotFound from "../HomeWork/Filter_Box/FilterNotFound";
import { SubjectIcon } from "../../SubjectIcon";
import "intro.js/introjs.css";
import { Steps } from "intro.js-react";
import ActivityTour from "../../SidebarHeader/Header/ActivityTour";
import { useLocation, useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { BookText, CalendarDays } from "lucide-react";
import { shortenParagraph } from "../../utils/Engagement";

export default function ActivityMain({ type }) {
  const [homeMain, setHomeMain] = useState({
    subMenu: localStorage.getItem("actSub") || "pending",
    activeData: null,
    ActivitypendingSubDetail: false,
    ActivityOnReviewSubDetail: false,
    ActivityCompletedSubDetail: false,
  });
  const navigate = useNavigate();
  const popupRef = useRef(null);
  const [stepsEnabled, setStepsEnabled] = useState(false);
  const [initialStep, setInitialStep] = useState(0);
  const [isSortPop, setIsSortPop] = useState(false);
  const [homeScreenWalkThroughPopup, setHomeScreenWalkThroughPopup] =
    useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const toggleFilterPopup = () => {
    // setIsPopupOpen(!isPopupOpen);
    setIsPopupOpen((prev) => !prev);
  };
  const togglePopup = () => {
    setIsSortPop(!isSortPop);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setIsPopupOpen(false);
      }
    };

    if (isPopupOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPopupOpen]);

  const { state } = useLocation()
  useEffect(() => {
    // Check if the popup has been shown before
    const hasShownPopup = localStorage.getItem("hasShownPopupActivity");
    if (!hasShownPopup) {
      // Show the steps if it hasn't been shown before
      setHomeScreenWalkThroughPopup(true);
      // Set the flag in localStorage to indicate the popup has been shown
      localStorage.setItem("hasShownPopupActivity", "true");
    }
  }, []);
  const [steps, setSteps] = useState([
    {
      element: ".FoterDetailContainer",
      intro: `
        <h3>Parent Features Bottom Pane</h3>
        <p>These are 4 Parents, each Parent has multiple features listed on the left most pane. Currently 'Homework' parent is selected.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".homeWork",
      intro: `
        <h3>Smart.Homework</h3>
        <p>Smart.Homework has 4 features (as shown in left most pane):
       </p>
       <ol>
          <li>Homework</li>
          <li>Pre-Read</li>
          <li>Activity</li>
        </ol>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".featuredLeftPaneHWM",
      intro: `
        <h3>Features Group Left Pane
        Smart.Homework has 3 features as shown:</h3>
        <ol>
        <li>Homework</li>
        <li>Pre-Read</li>
        <li>Activity</li>
        </ol>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".activity",
      intro: `
        <h3>Activity</h3>
        <p>Currently 'Pre-Read' feature is selected, Let's navigate through this feature</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },

    {
      element: ".subWiseA ",
      intro: `
        <h3>Subject Wise Activity</h3>
        <p>You can see subject wise Activity count for 'pending', 'review' and 'completed'</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".CardsA  ",
      intro: `
        <h3>Cards Section</h3>
        <p>You can open Activities from this section.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".pendingA",
      intro: `
        <h3>Pending</h3>
        <p>In this tab you will find Activities which needs to be submitted by you.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".reviewA",
      intro: `
        <h3>On Review</h3>
        <p>You will find your submitted Activities which are yet to be reviewed by teacher.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".completedA",
      intro: `
        <h3>Completed</h3>
        <p>You will find your submitted Ativities which are reviewed by teacher.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },

    {
      element: ".filterA",
      intro: `
        <h3>Filter</h3>
        <p>Using filter button you can filter items by subject time and date wise.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".sortByA",
      intro: `
        <h3>Sort By</h3>
        <p>Using Sort by Button you can sort items in ascending or descending based on date.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".prifilePic",
      intro: `
        <h3>Your profile, B4S App layout</h3>
        <p>Access your profile Information.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".done",
      intro: `
        <h3>Awesome, you are done. 😊</h3>
        <p>Click anywhere on the screen or click on the cross icon.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
  ]);
  const onExit = () => {
    setStepsEnabled(false);
  };
  const [noContentClick, setNoContentClick] = useState(false);

  const [cards, setCards] = useState([]);
  // const [ispopupopen, setIsPopupOpen] = useState(false);

  const [rotation, setRotation] = useState(0);

  const rotateImage = () => {
    setRotation((rotation) => rotation + 180);
  };

  const currentUser = useSelector((state) => state.user.currentUser);
  const [isGettingData, setIsGettingData] = useState(true);
  const [filter, setFilter] = useState({
    subjectId: [],
    date: "",
    time: "",
    sortBy: -1,
    limit: 20,
    page: 1,
  });
  const today = new Date().toISOString().split("T")[0];

  useEffect(() => {
    const pendingBox = async () => {
      setIsGettingData(true);
      let response = await axios.get(
        `/homework/activity/filterByStudentId/${currentUser?.id}/${homeMain.subMenu}?_page=${filter?.page}&_limit=${filter?.limit}&sortBy=${filter?.sortBy}` +
        `${filter?.date
          ? `&date=${moment(filter?.date).format("YYYY-MM-DD")}`
          : ``
        }` +
        `${filter?.time ? `&time=${filter?.time}` : ``}` +
        `${filter?.subjectId?.length !== 0
          ? `&subjectId=${filter?.subjectId}`
          : ``
        }`
      );
      response && setCards(response.data.data);
      setIsGettingData(false);
    };
    pendingBox();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, homeMain.subMenu]);

  const handlePendingActivitySubDetail = () => {
    setHomeMain({
      ...homeMain,
      subMenu: "pending",
      ActivitypendingSubDetail: false,
    });
  };
  const handlePendingOnreviewSubDetail = () => {
    setHomeMain({
      ...homeMain,
      subMenu: "review",
      ActivityOnReviewSubDetail: false,
    });
  };
  const handlePendingCompletedSubDetail = () => {
    setHomeMain({
      ...homeMain,
      subMenu: "completed",
      ActivityCompletedSubDetail: false,
    });
  };


  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const userOffset = dateObj.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
    const localDate = new Date(dateObj - userOffset); // Convert to local time

    const day = localDate.getDate().toString().padStart(2, "0");
    const month = (localDate.getMonth() + 1).toString().padStart(2, "0");
    const year = localDate.getFullYear();
    const outputDateString = `${day}/${month}/${year}`;
    return outputDateString;
  };


  return (
    <>
      <div className="h-100">
        <Steps
          enabled={stepsEnabled}
          steps={steps}
          initialStep={initialStep}
          onExit={onExit}
        />
        <div className="pending_completed_container1 relative ">
          <div className="text-2xl font-semibold text-blue-950">Subject-wise Activity</div>
          <div className="subjectBoxContainer mt-3 subWiseA">
            <SubjBoxProps />
          </div>

          <div className="homeWorkSubContainer">
            <div className="d-flex ">
              <div className="d-flex mt-3 col-3 p-0 HomeWorkSubPartsMenuTotal">
                <div
                  className={
                    homeMain.subMenu === "pending"
                      ? "HomeWorkSubPartsMenuActive pendingA"
                      : "HomeWorkSubPartsMenu pendingA"
                  }
                  onClick={() => {
                    homeMain.subMenu !== "pending" && setCards([]);
                    setHomeMain({ ...homeMain, subMenu: "pending" });
                    localStorage.setItem("actSub", "pending");
                  }}
                >
                  Pending
                </div>

                <div
                  // className='HomeWorkSubPartsMenu d-flex justify-content-center'
                  className={
                    homeMain.subMenu === "review"
                      ? "HomeWorkSubPartsMenuActive d-flex justify-content-center mr-3 reviewA"
                      : "HomeWorkSubPartsMenu mr-3 d-flex justify-content-center reviewA"
                  }
                  onClick={() => {
                    homeMain.subMenu !== "review" && setCards([]);
                    setHomeMain({ ...homeMain, subMenu: "review" });
                    localStorage.setItem("actSub", "review");
                  }}
                >
                  On Review
                </div>

                <div
                  // className='HomeWorkSubPartsMenu d-flex justify-content-center'
                  className={
                    homeMain.subMenu === "completed"
                      ? "HomeWorkSubPartsMenuActive d-flex justify-content-center completedA"
                      : "HomeWorkSubPartsMenu d-flex justify-content-center completedA"
                  }
                  onClick={() => {
                    homeMain.subMenu !== "completed" && setCards([]);
                    setHomeMain({ ...homeMain, subMenu: "completed" });
                    localStorage.setItem("actSub", "completed");
                  }}
                >
                  Completed
                </div>
              </div>
              <div className="d-flex gap-4 align-items-center justify-content-end col-8 horizontalLine p-0 ">
                <div className="mb-3 filterA">
                  <div
                    className="col-md-12 gap-2 filter_box"
                    onClick={toggleFilterPopup}
                  >
                    <img
                      className="filter_icon"
                      src="/HwImg/filter Icon.svg"
                      alt=""
                    />
                    <span>Filter</span>
                  </div>
                  {/* <Popup
                    on="click"
                    open={isPopupOpen}
                    onClose={togglePopup}
                    onOpen={togglePopup}
                    className="popUpFilter_ass"
                    trigger={

                    }
                    content={

                    }
                    position="bottom center"
                  /> */}
                </div>
                <div
                  className="d-flex gap-2 align-items-center  mb-3 sortByA"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    togglePopup()
                    rotateImage()
                  }}
                >
                  <div className="sortby">Sort by</div>
                  <div>
                    <img
                      src="/HwImg/DownArrowSort.png"
                      alt=""
                      style={{ transform: `rotate(${rotation}deg)` }}
                    ></img>
                  </div>
                </div>

                {/* <Popup
                  on="click"
                  className="popUpFilter_ass"
                  trigger={

                  }
                  content={
                    <SortedBy
                      filter={filter}
                      setFilter={setFilter}
                      togglePopup={togglePopup}
                    />
                  }
                  position="bottom center"
                /> */}
              </div>
            </div>
          </div>
        </div>

        <div className="pending_completed_container2 mt-4 orange-scrollBar"
          style={{ maxHeight: "50vh", overflowY: "scroll", paddingBottom: "5px" }}
        >
          {homeMain.subMenu === "pending" && (
            <>
              {cards.length > 0 ? (
                <div className="d-flex flex-wrap gap-3">
                  {cards.map((card, index) => (
                    <div
                      key={index}
                      onClick={() => {
                        setHomeMain({
                          ...homeMain,
                          ActivitypendingSubDetail: true,
                          activeData: card,
                        });
                        navigate(`/publishedActivity`, { state: { activityId: card?.id } });
                      }}
                      className="w-80 h-32 d-flex flex-column py-2 px-3 text-start shadow-sm rounded-4 cursor-pointer card_style"
                      style={{
                        borderTop: `8px solid #${card?.subject_id?.subject_color}`,
                        position: "relative"
                      }}
                    >
                      <div
                        className="d-flex SubsummarySubBoxContainer justify-content-between align-items-center"
                      >
                        <div>
                          <div className="subboxSubjectName">
                            {card?.subject_id?.name}
                          </div>
                        </div>
                        <div>
                          <img
                            src={`${SubjectIcon?.find(
                              (i) => i.subjectName === card?.subject_id?.name
                            )?.icon
                              }`}
                            alt=""
                          />
                        </div>
                      </div>
                      <div
                        className="d-flex justify-content-start"
                        onClick={() =>
                          setHomeMain({ ...homeMain, PreReadSubDetail: true })
                        }
                      >
                        <div className="d-flex align-items-center">
                          {/* <img src="/HwImg/ActivityFile.png" alt=""></img> */}
                        </div>
                        <div>
                          {/* <div className="subjectPreRead">
                            {card?.subject_id?.name}
                          </div> */}
                          {/*  */}
                          <div className="SubChapName mt-1">{
                            <Tooltip
                              title={card?.name}
                              arrow
                              placement="bottom"
                              enterDelay={200}
                              leaveDelay={100}
                            >
                              <div className="flex">
                                <BookText size={16} className="me-2 mt-1 text-dark" />
                                {shortenParagraph(card?.name, 30)}
                              </div>
                            </Tooltip>
                          }</div>
                          <div className="flex mt-2">
                            <CalendarDays size={16} className="me-2 text-dark" />
                            <span className="Deadlinetxt">Deadline:</span>
                            <span className="DeadlineDateActivity">
                              &nbsp;{timeHelper(card?.deadline)}
                            </span>
                          </div>
                        </div>
                        <span
                          style={{
                            color: "#FF0000",
                            fontSize: "16px",
                            fontWeight: "600",
                            position: "absolute",
                            bottom: "5px",
                            right: "10px",
                          }}
                        >
                          {moment(card?.deadline).format("YYYY-MM-DD") < today
                            ? "Delayed"
                            : " "}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              ) : isGettingData ? (
                <img
                  className="ongoing_loader"
                  src="/gif/LoaderDot.gif"
                  alt=""
                />
              ) : (
                <span>Activity Not Found</span>
                //  : noContentClick ? (
                //   <span>Activity Not Found</span>
                // ) : (
                //   <FilterNotFound setNoContentClick={setNoContentClick} />
              )}
            </>
          )}
          {homeMain.subMenu === "review" && (
            <>
              {cards.length > 0 ? (
                <div className="d-flex flex-wrap gap-3">
                  {cards.length >= 0 &&
                    cards.map((card, index) => (
                      <div
                        key={index}
                        onClick={() =>
                          // setHomeMain({
                          //   ...homeMain,
                          //   ActivityOnReviewSubDetail: true,
                          //   activeData: card,
                          // })
                          navigate(`/reviewActivity`, { state: { activityId: card?.id } })
                        }
                        className="w-80 h-32 d-flex flex-column py-2 px-3 text-start shadow-sm rounded-4 cursor-pointer card_style"
                        style={{
                          borderTop: `8px solid #${card?.subject_id?.subject_color}`,
                          position: "relative"
                        }}
                      >
                        <div
                          className="d-flex SubsummarySubBoxContainer justify-content-between align-items-center"
                        >
                          <div>
                            <div className="subboxSubjectName">
                              {card?.subject_id?.name}
                            </div>
                          </div>
                          <div>
                            <img
                              src={`${SubjectIcon?.find(
                                (i) =>
                                  i.subjectName === card?.subject_id?.name
                              )?.icon
                                }`}
                              alt=""
                            />
                          </div>
                        </div>
                        <div
                          className="d-flex justify-content-start"
                          onClick={() =>
                            setHomeMain({ ...homeMain, PreReadSubDetail: true })
                          }
                        >
                          <div>
                            {/* <div className="subjectPreRead">
                            {card?.subject_id?.name}
                          </div> */}
                            <div className="SubChapName mt-1">{
                              <Tooltip
                                title={card?.name}
                                arrow
                                placement="bottom"
                                enterDelay={200}
                                leaveDelay={100}
                              >
                                <div className="flex">
                                  <BookText size={16} className="me-2 mt-1 text-dark" />
                                  {shortenParagraph(card?.name, 30)}
                                </div>
                              </Tooltip>
                            }</div>
                            <div className="flex mt-2">
                              <CalendarDays size={16} className="me-2 text-dark" />
                              <span className="deadline">Submitted: </span> &nbsp;
                              <span className="deadlineDate">
                                {timeHelper(card?.submitted_on)}
                              </span>
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#FF0000",
                              fontSize: "16px",
                              fontWeight: "600",
                              position: "absolute",
                              bottom: "0px",
                              right: "10px",
                            }}
                          >
                            {moment(card?.deadline).format("YYYY-MM-DD") <
                              moment(card?.submitted_on).format("YYYY-MM-DD")
                              ? "Delayed Submission"
                              : " "}
                          </span>
                        </div>
                      </div>
                    ))}
                </div>
              ) : isGettingData ? (
                <img
                  className="ongoing_loader"
                  src="/gif/LoaderDot.gif"
                  alt=""
                />
              ) : (
                <span>Activity Not Found</span>
                //  : noContentClick ? (
                //   <span>Activity Not Found</span>
                // ) : (
                //   <FilterNotFound setNoContentClick={setNoContentClick} />
              )}
            </>
          )}
          {homeMain.subMenu === "completed" && (
            <>
              {cards.length > 0 ? (
                <div className="d-flex justify-content-start gap-3  flex-wrap">
                  {cards.length >= 0 &&
                    cards.map((card, index) => (
                      <div
                        key={index}
                        onClick={() =>
                          // setHomeMain({
                          //   ...homeMain,
                          //   ActivityCompletedSubDetail: true,
                          //   activeData: card,
                          // })
                          navigate(`/completedActivity`, { state: { activityId: card?.id } })
                        }
                        // className="summarySubBoxContainerHW"
                        // style={{ maxHeight: "120px", position: "relative" }}
                        className="w-80 h-32 d-flex flex-column py-2 px-3 text-start shadow-sm rounded-4 cursor-pointer card_style"
                        style={{
                          borderTop: `8px solid #${card?.subject_id?.subject_color}`,
                          position: "relative"
                        }}
                      >
                        <div
                          className="d-flex SubsummarySubBoxContainer justify-content-between align-items-center"
                        >
                          <div>
                            <div className="subboxSubjectName">
                              {card?.subject_id?.name}
                            </div>
                          </div>
                          <div>
                            <img
                              src={`${SubjectIcon?.find(
                                (i) =>
                                  i.subjectName === card?.subject_id?.name
                              )?.icon
                                }`}
                              alt=""
                            />
                          </div>
                        </div>
                        <div
                          className="d-flex justify-content-start"
                          onClick={() =>
                            setHomeMain({ ...homeMain, PreReadSubDetail: true })
                          }
                        >
                          <div>
                            {/* <div className="subjectPreRead">
                            {card?.subject_id?.name}
                          </div> */}
                            <div className="SubChapName mt-1">{<Tooltip
                              title={card?.name}
                              arrow
                              placement="bottom"
                              enterDelay={200}
                              leaveDelay={100}
                            >
                              <div className="flex">
                                <BookText size={16} className="me-2 mt-1 text-dark" />
                                {shortenParagraph(card?.name, 30)}
                              </div>
                            </Tooltip>}</div>
                            <div className="flex mt-2">
                              <CalendarDays size={16} className="me-2 text-dark" />
                              <span className="deadline">Submitted</span> &nbsp;
                              <span className="deadlineDate">
                                {timeHelper(card?.submitted_on)}
                              </span>
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#FF0000",
                              fontSize: "16px",
                              fontWeight: "600",
                              position: "absolute",
                              bottom: "5px",
                              right: "10px",
                            }}
                          >
                            {moment(card?.deadline).format("YYYY-MM-DD") <
                              moment(card?.submitted_on).format("YYYY-MM-DD")
                              ? "Delayed Submission"
                              : " "}
                          </span>
                        </div>
                      </div>
                    ))}
                </div>
              ) : isGettingData ? (
                <img
                  className="ongoing_loader"
                  src="/gif/LoaderDot.gif"
                  alt=""
                />
              ) : (
                <span>Activity Not Found</span>
                //  : noContentClick ? (
                //   <span>Activity Not Found</span>
                // ) : (
                //   <FilterNotFound setNoContentClick={setNoContentClick} />
              )}
            </>
          )}
        </div>
      </div>

      {/* {homeMain.ActivitypendingSubDetail && (
        <ActivityPendingSubjDetail
          handlePendingActivitySubDetail={handlePendingActivitySubDetail}
          homeMain={homeMain.activeData}
        />
      )} */}
      {/* {homeMain.ActivityOnReviewSubDetail && (
        <ActivityOnReviewSubDetail
          handlePendingOnreviewSubDetail={handlePendingOnreviewSubDetail}
          homeMain={homeMain.activeData}
        />
      )} */}
      {/* {homeMain.ActivityCompletedSubDetail && (
        <ActivityCompletedSubDetail
          handlePendingCompletedSubDetail={handlePendingCompletedSubDetail}
          homeMain={homeMain.activeData}
        />
      )} */}
      {homeScreenWalkThroughPopup && (
        <ActivityTour
          setHomeScreenWalkThroughPopup={setHomeScreenWalkThroughPopup}
          setStepsEnabled={setStepsEnabled}
        />
      )}
      {
        isPopupOpen && (
          <div ref={popupRef}>
            <FilterBox
              setFilter={setFilter}
              filter={filter}
              toggleFilterPopup={toggleFilterPopup}
              type={type}
            />
          </div>
        )
      }
      {
        isSortPop && (
          <SortedBy
            filter={filter}
            setFilter={setFilter}
            togglePopup={togglePopup}
            type={type}
          />
        )
      }
    </>
  );
}
